<template>
    <v-dialog v-model="dialog" persistent max-width="340">
        <v-card class="pa-3">
        <!-- Header -->
            <v-card-title v-if="header" class="title font-weight-regular pb-1">{{header}}</v-card-title>
        <!-- Text -->
            <v-card-text :class="[{'error--text': warningColor}, 'pt-4 pb-3']">
                <span v-if="question">{{question}}</span>
                <slot></slot>
            </v-card-text>
        <!-- Schließen -->
            <v-card-actions>
                <v-btn color="grey" text @click="reply(false)">
                    {{ buttonNo }}
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn :color="btnColor" text @click="reply(true)">
                    {{ buttonYes }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    export default {
        name: "confirm-dialog",
        props: {
        // navigation and control
            open: {default: false},
            queryParameter: {default: 'confirmCancel'},
            id: {default: null},
        // texts
            header: {default: ''},
            question: {default: ''},
            warningColor: {default: false},
        // without router
            withoutRouter: { default: false},
        // buttons
            buttonYes: {default: 'Ja'},
            buttonNo: {default: 'Nein'},
        },
        data: () => ({
            dialog: false,
            selected: false,
        }),
        computed: {
            path () {return this.$route.query[this.queryParameter] },
            btnColor() { return this.warningColor ? 'error' : 'primary'},
        },
        created () {
            if ( this.$route.query[this.queryParameter] ) {
                window.history.back();
            }
        },
        methods: {
            openDialog () {
                if ( (this.id && this.id === this.open || !this.id) ) {
                    this.dialog = true;
                    // router setzen
                    if ( !this.withoutRouter ) {
                        let p = JSON.parse(JSON.stringify(this.$route.path));
                        let q = JSON.parse(JSON.stringify(this.$route.query));
                        q[this.queryParameter] = this.open;
                        this.$router.push({path: p, query: q});
                    }
                }
            },
            reply(selection){
                this.selected = selection;
                if ( !this.withoutRouter ) {
                    window.history.back();
                } else {
                    this.$emit("reply", this.selected);
                }
            }
        },
        watch: {
            path (to, from) {
                if ( (this.id && this.id === this.open || !this.id) ) {
                    console.log ("watch path:", to, from);
                    if ( to === undefined && from ) {
                        console.log ("watch path emit:", to, from);
                        this.$emit("reply", this.selected);
                    }
                }
            },
            open (to) {
                console.log ("watch open:", to);
                if ( to ) {
                    this.openDialog();
                } else {
                    this.dialog = false;
                }
            }
        }
    }
</script>

<style scoped>

</style>